module.exports = __webpack_public_path__ + "img/IDA_white.cfe46097.svg";